import {Observable} from "rxjs";
import {FileEntry} from "./fileEntry";

export enum UploadStatus {
  UPLOADED = 'UPLOADED',
  DELETED = 'DELETED',
  DOWNLOADED = 'DOWNLOADED',
  IN_PROGRESS = 'IN PROGRESS',
  ERROR = 'ERROR'
}

export interface UploadResponse {
  body?: FileEntry|Error|Blob|ArrayBuffer;
  status: UploadStatus;
  progress?: number;
}

export abstract class FilePickerAdapter {
  public abstract get isLoading();
  public abstract uploadFile(file: File, moredata: {[key:string]: any}): Observable<UploadResponse>;
  public abstract removeFile(file: FileEntry): Observable<UploadResponse>;
  public abstract downloadFile(file: FileEntry): Observable<UploadResponse>;
}
